import { apiBaseSlices } from "./baseAPI";

export const ghlAuthsSlices = apiBaseSlices.injectEndpoints({
    endpoints: (builder) => ({
        getGhlAuthList: builder.mutation({
            query: ({ token, currentPage }) => ({
                url: `ghl-auths?page=${currentPage}`,
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            }),
        }),

        getGhlAuth: builder.mutation({
            query: ({ ghlAuthId, token }) => {
                return {
                    url: `ghl-auths/${ghlAuthId}`,
                    method: "GET",
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }
            },
        }),

        updateGhlAuth: builder.mutation({
            query: ({ payload, ghlAuthId, token }) => ({
                url: `ghl-auths/${ghlAuthId}`,
                method: "PUT",
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: payload,
            }),
        }),

        deleteGhlAuth: builder.mutation({
            query: ({ ghlAuthId, token }) => ({
                url: `ghl-auths/${ghlAuthId}`,
                method: "DELETE",
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            }),
        }),

        getGhlOAuthUrl: builder.mutation({
            query: ({ token }) => ({
                url: `ghl-auths/oauth-url`,
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            }),
        }),

        syncGhlUsers: builder.mutation({
            query: ({ ghlAuthId, token }) => ({
                url: `ghl-auths/${ghlAuthId}/sync-users`,
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            }),
        }),

        updateGhlUser: builder.mutation({
            query: ({ ghlUserId, payload, token }) => ({
                url: `ghl-users/${ghlUserId}`,
                method: "PUT",
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: payload,
            }),
        }),
    }),
});

export const {
    useGetGhlAuthListMutation,
    useGetGhlAuthMutation,
    useUpdateGhlAuthMutation,
    useDeleteGhlAuthMutation,
    useGetGhlOAuthUrlMutation,
    useSyncGhlUsersMutation,
    useUpdateGhlUserMutation,
} = ghlAuthsSlices;
